import { SelectStatementColumn } from './../../../models/select-statement-column.model';
import { HelpService } from './../../help/help.service';
import { Title } from '@angular/platform-browser';
import { StockService, IssueDataChart, IssueDataTable, OverviewFiltersOutput, TaskDataFilter } from './../stock.service';
import { Component, OnInit, ElementRef, ViewChild, inject } from '@angular/core';
import { DynamicTable } from 'src/app/models/dynamicTable';
import { ActivatedRoute, Data } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { ShareDataService } from 'src/app/services/share-data.service';
import { TaskService } from '../../task/task.service';
import { QueryFilterParameter } from 'src/app/widgets/filters/models/query-filter-parameter.model';
import { ExportFilter, FilterMappingService } from 'src/app/models/filter-objects';
import { FileExportService } from 'src/app/common/file-export-service';
import { SettingsService } from '../../settings/settings.service';
import { UtilsService } from 'src/app/services/utils.service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';

@Component({
    selector: 'app-issue-development',
    templateUrl: './issue-development.component.html',
    styleUrls: ['./issue-development.component.scss'],
    standalone: false
})
export class IssueDevelopmentComponent implements OnInit {
	//charts
	chartData: IssueDataChart[] = [];
	chartDataWithOutChage: any;
	@ViewChild('firstChartContainer', { static: false }) firstChartContainer: ElementRef;
	//table
	tableColumns: SelectStatementColumn[] = [];
	tableDataSource = [];
	tableData: DynamicTable;
	@ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
	fitTableToPage = false;

	//ids
	selectedProductId = '';

	isShowReset = false;
	//Filters
	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
		  {
			filters: async () => this.pageFiltersOperator.appliedFilters,
	
			baseSelectStatementId: BaseSelectStatementId.DEV_StockControllingIssueDevelopmentFilter,
			selectionSetId: SelectionSetId.IssueDevelopmentListFilter,
		  }
		)
	);
	//Bookmark
	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;
	  
	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
	public bookmarkElementsOperators: BookmarkElementsOperator[];
	
	public async initializeBookmarks(): Promise<Data> {
	let routeData: Data = await firstValueFrom(this._activatedRoute.data);
	
	this.bookmarkElementsOperators = [
		new FiltersGroupBookmarkElementsOperator(
		  {
			id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
			filtersOperator: () => this.pageFiltersOperator
		  }
		)
	];
	
	return routeData;
	}

	constructor(
		private stockService: StockService,
		private titleService: Title,
		private helpService: HelpService, private settingsService: SettingsService,
		private taskService: TaskService, private shareDataService: ShareDataService,
		private route: ActivatedRoute, private fileExportService: FileExportService) {
		this.shareDataService.CleanData();
	}

	taskFilterData: TaskDataFilter[];
	IsTaskLoad = false;
	async ngOnInit() {
		this.titleService.setTitle("Stock Issue Development");

		this.route.paramMap.subscribe(
			params => {
				const value = this.route.snapshot.queryParamMap.get("taskid");
				if (value) {
					this.taskService.SelectTaskFilterValues(value).subscribe(data => {
						this.taskFilterData = data;
						this.taskFilterData.forEach(
							(_) => {
			  
							}
						  );
						  this.pageFiltersOperator.load(
							{
							  showLoadingIndicator: true,
							}
						  );
						this.loadPageData();
						this.initData();
					}, err => {

					});

				}
			});
		this.GetSettingsData();
		this.SettingsGroupByName();
		await this.initializeBookmarks();
    	this.loadPageData();
    	this.pageFiltersOperator.onFiltersApplied.subscribe(
      	 (selection) => {
         	this.shareDataService.CleanData();
         	this.shareDataService.filterOptionOverview = selection.output;
         	this.pageFiltersOperator.load(
         	  {
         	    showLoadingIndicator: true,
         	  }
         	);
		 	this.initData();
         	this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.shareDataService.filterOptionOverview.filters);
      	 }
    	);
	}

	public async loadPageData() {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (_) => {
					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
						this.initData();
					}
				}
			}
		);
	}

	private initData() {
		this.filterOptions = new OverviewFiltersOutput();
		this.filterOptions.action = this.action;
		this.filterOptions.settingGroupId = 1;
		this.filterOptions.filters = [];
		if (this.pageFiltersOperator.overviewFiltersOutput.filters) {
		  this.pageFiltersOperator.overviewFiltersOutput.filters.forEach(element => {
			let filterItem: QueryFilterParameter = new QueryFilterParameter(
			  element.fieldName,
			  element.value,
			  element.operation
			);
			this.filterOptions.filters.push(filterItem);
		  });
		}
		this.stockService.getIssueDataNew(this.filterOptions).subscribe(res => {
			this.tableDataSource = [];
			this.chartDataWithOutChage = JSON.parse(JSON.stringify(res.chartData));
			this.initChartData(res.chartData);
			this.initTableData(res.tableData);

		});
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-stock-issue', JSON.stringify(this.dataGrid.instance.state()));
	}

	private initChartData(chartData: IssueDataChart[]) {
		let updatedNewIssues: string[] = [];
		chartData.forEach(item => {
			if (item.oldIssue === item.newIssue) {
				updatedNewIssues.push(item.newIssue);
				item.newIssue = item.newIssue + ' ';
			} else if (updatedNewIssues.filter(issue => issue === item.newIssue)) {
				item.newIssue = item.newIssue + ' ';
			}
		});
		this.chartData = chartData;
	}

	private initTableData(table: IssueDataTable) {
		this.tableColumns = table.captions;
		table.data.rows.map(row => row.fields.map(fild => fild)).forEach(
			item => {
				const createRow = {};
				item.forEach(el => { createRow[el.name] = el.value; });
				this.tableDataSource.push(createRow);
			}
		);
	}


	customizeLinkTooltip(info: any, CurrentStockControllingId, LastStockControllingId) {
		var $this = this;
		console.log('****************', this, $this)
		return {
			html: `<b>Last Issue:</b> ${info.source}<br/><b>Current Issue:</b> ${info.target}<br/><b>Total Count:</b> ${info.weight}
      <br/><b>CurrentStockControllingId:</b> ${CurrentStockControllingId}<br/><b>LastStockControllingId:</b> ${LastStockControllingId}<br/>
      `
		};
	}

	getProductData(e, data) {
		e.event.stopPropagation();
		this.selectedProductId = data.data.ProductId;
		let url = 'stock/deep-dive?id=' + UtilsService.getURLHelper(this.selectedProductId);
		window.open(url, '_blank');
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;

		toolbarItems.unshift({
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		},{
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		});
	}

	changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	tableFiltering(event: any) {
		this.isShowReset = true;
		const source = event.target.connection.source;
		var target = event.target.connection.target;
		if (this.chartDataWithOutChage != null && this.chartDataWithOutChage != undefined && this.chartDataWithOutChage.length > 0) {
			var Item = this.chartDataWithOutChage.find(x => x.newIssue + ' ' == target);
			if (Item != null && Item.newIssue != null) {
				target = Item.newIssue;
			}
		}

		this.dataGrid.instance.filter(item => {
			return (item['Issue'] === target && item['IssueOld'] === source);
		});
	}

	resetGridFilters() {
		this.isShowReset = false;
		this.dataGrid.instance.clearFilter();
	}

	//filter variables
	action = "Filter";
	filterOptions: OverviewFiltersOutput;

	/* Export Option */
	IsExportEnable = false;
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportStockIssueDevelopment").subscribe(resultFilename => {
			this.IsExportEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err);
		});
		this.fileExportService.WebSettings("EnableExportStockIssueDevelopmentlist").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err, "err");
		});
	}

	CurrentStockControllingId = "";
	LastStockControllingId = "";
	SettingsGroupByName() {
		this.settingsService.SettingsGroupByName("StockIssueId", "StockIssueId").subscribe(result => {
			if (result != null && result.table != null) {

				if (result.table.filter(x => x.name == 'CurrentStockControllingId') && result.table.filter(x => x.name == 'CurrentStockControllingId').length > 0) {
					this.CurrentStockControllingId = result.table.filter(x => x.name == 'CurrentStockControllingId')[0].value;
				}
				if (result.table.filter(x => x.name == 'LastStockControllingId') && result.table.filter(x => x.name == 'LastStockControllingId').length > 0) {
					this.LastStockControllingId = result.table.filter(x => x.name == 'LastStockControllingId')[0].value;
				}
				console.log(this.CurrentStockControllingId, this.LastStockControllingId)
			}
		});
	}

	filterMappingService = new FilterMappingService();
	ExportToExcelFilters: ExportFilter[] = [];
	 // Method to receive value from child
	receiveExportToExcelFilters(value: ExportFilter[]) {
		this.ExportToExcelFilters = value;
	}
}
